import { useNavigate } from "react-router-dom";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { PanelTitle } from "@shared/ui/PanelTitle";

export function OnboardingSignupSuccess() {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/onboarding");
  };

  return (
    <PanelTitle
      title="You’re in the Pollinator program for October, 2025!"
      description="Next up, help us match you with five aligned peers."
      isInverted
      className="flex-1"
    >
      <ActionButtonsGroup
        onPrimaryClick={handleContinue}
        primaryButtonText={"Continue"}
        theme="dark"
      />
    </PanelTitle>
  );
}

export default OnboardingSignupSuccess;
